import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, transition, style, animate, state } from '@angular/animations'
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter';

import { DisplayStateService, Events } from '../../../services/DisplayStateService';

@Component({
  selector: 'app-main-display',
  template: `<!-- display an auth message if user does not exist yet -->
<div id="authenticating-message-container" *ngIf="showWaitingUser; else userExists">
    <div style="text-align: center; padding: 10px;" id="authenticating-message">
        <h3>Hold on... We are figuring out who you are</h3>
        <h4>Authenticating...</h4>
        <i class="fa fa-spinner fa-spin fa-5x"></i>
    </div>
</div>

<!-- user exists - show the left nav & main area-->
<ng-template #userExists>
    <div class="wrapper">
        <!-- load the top-nav -->
        <header>
            <app-top-nav></app-top-nav>
        </header>
        <main>
            <div class="sidenav bg-faded" [@sideNavAnimation]="sideNavState">
                <app-side-nav></app-side-nav>
            </div>
            <div id="main" [@mainSectionAnimation]="sideNavState">
                <app-group-display></app-group-display>
            </div>
        </main>


    </div>
</ng-template>`,
  styles: [`.sidenav{
    height:calc(100vh - 80px);
    position:fixed;
    z-index:1;
    overflow-x:hidden;
    min-width:245px;
    will-change:transform;
    padding:.30em .30em 0 .30em;
}

#main{
    will-change:margin-left;
    margin-left:245px;
    padding:.30em .30em 0 .30em;
}

@media screen and (max-height: 450px){
    .sidenav{
        padding-top:15px;
    }
    .sidenav a{
        font-size:18px;
    }
}

.wrapper{
    padding-top:70px;
    height:100%;
}`],
  animations: [
    trigger('sideNavAnimation', [
      state('show', style({
        transform: 'translate3d(0, 0px, 0px)',
      })),
      state('hide', style({
        transform: 'translate3d(-100%, 0px, 0px)',
      })),
      transition('show <=> hide', animate('500ms cubic-bezier(.25,.8,.25,1)')),
    ]),
    trigger('mainSectionAnimation', [
      state('show', style({
        marginLeft: '245px',
      })),
      state('hide', style({
        marginLeft: '0',
      })),
      transition('show <=> hide', animate('500ms cubic-bezier(.25,.8,.25,1)')),
    ]),
  ]
})
export class MainDisplayComponent implements OnInit, OnDestroy {
  statechanged$: Subscription;
  showWaitingUser = true;
  sideNavState = 'show';
  constructor(public DisplayStateService: DisplayStateService) {
  }

  ngOnInit() {
    this.showWaitingUser = this.DisplayStateService.appState.current.user === undefined;
    this.statechanged$ = this.DisplayStateService.AppStateChanged.subscribe(x => {
      if (x === Events.SIDE_NAV_DISPLAYED_CHANGED) {
        if (this.DisplayStateService.appState.current.sideNav.displayState) {
          this.sideNavState = this.DisplayStateService.appState.current.sideNav.displayState;
        } else {
          this.sideNavState = 'show';
        }
      } else if (x === Events.USER_CHANGED) {
        this.showWaitingUser = false;
      }

    });
  }

  ngOnDestroy() {
    this.statechanged$.unsubscribe();
  }

}
